import * as React from 'react';
import Row from 'reactstrap/lib/Row';
import { Col } from 'reactstrap';
import Label from 'reactstrap/lib/Label';
import { ICaseBinderList } from 'src/share/types/match';

export interface ICaseBinderListProps {
  suspectId: string;
  caseBinderList: ICaseBinderList[];
}

const CaseBinderList = (props: ICaseBinderListProps) => (
  <Row key={`case-binder-list-${props.suspectId}`}>
    <ul className="binder-list">
      <Col md={12} className="stats-info binder-list-title">
        <h2>Case Binder List</h2>
      </Col>
      {props.caseBinderList.map(arrest =>
        <Row className="biometrica-binder-list" key={arrest.id}>
          <Col md={12} className="stats-info">
            <li><p><Label>Arrest number:</Label>{arrest.arrestNumber || 'Unknown'}</p></li>
            <p><Label>Status:</Label>{arrest.status || 'Unknown'}</p>
            <p><Label>Sentence:</Label>{arrest.sentence || 'Unknown'}</p>
          </Col>
        </Row>
      )}
    </ul>
  </Row>
);

export default CaseBinderList;



// WEBPACK FOOTER //
// ./src/modules/Recognition/BoundingBox/Biometrica/BiometricaBinderList/CaseBinderList.tsx